import { makeStyles } from '@material-ui/core/styles';

export const useContentStyles = makeStyles(() => ({
  container: {
    background: 'white',
    minHeight: props => props.mobile ? 'calc(100vh - 230px)' : 'calc(100vh - 155px)'
  },
  innerContainer: {
    width: '100%',
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
    textAlign: 'center',
  },
}));
